module.exports = __webpack_public_path__ + "static/media/cultura.a58f6237.png";